import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsCommunicationHistoryToDosWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsCommunicationHistoryToDosWidgetService } from 'services/memberDetailsCommunicationHistoryToDosWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsCommunicationHistoryToDosWidgetService = new MemberDetailsCommunicationHistoryToDosWidgetService();
 * const result = await memberDetailsCommunicationHistoryToDosWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsCommunicationHistoryToDosWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsCommunicationHistoryToDosWidgetService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { data, url } ) {

        const response = await this.post( {
            host: CONFIG.host,
            path: url,
            data,
        } );

        return {
            status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
            data: get( response, 'body.component', {} ),
        };
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
